export const PLAYWRIGHT_CHAIN_ID = '__PLAYWRIGHT_CHAIN_ID' as const
export const PLAYWRIGHT_WALLET_ADDRESS_KEY = '__PLAYWRIGHT_WALLET_ADDRESS' as const
export const PLAYWRIGHT_WALLET_PRIVATE_KEY_KEY = '__PLAYWRIGHT_WALLET_PRIVATE_KEY' as const
export const PLAYWRIGHT_WALLET_FORK_URL_KEY = '__PLAYWRIGHT_WALLET_FORK_URL_KEY' as const
export const PLAYWRIGHT_WALLET_ATOMIC_BATCH_SUPPORTED_KEY = '__PLAYWRIGHT_WALLET_ATOMIC_BATCH_SUPPORTED' as const
export const PLAYWRIGHT_SUSDC_CONTRACTS_AVAILABLE_KEY = '__PLAYWRIGHT_SUSDC_CONTRACTS_AVAILABLE' as const
